import ReCaptcha from 'react-google-recaptcha'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'

const Captcha = (props) => {
  const { siteKey, recaptchaCallback, recaptchaInstance } = props

  return (
    <Flex alignX='center' paddingTop={2}>
      <Box>
        <ReCaptcha
          sitekey={siteKey}
          onChange={recaptchaCallback}
          ref={recaptchaInstance}
        />
      </Box>
    </Flex>
  )
}

export default Captcha
